export default [
    {
        path: '/offer-partners',
        name: 'PageOfferPartnersList',
        meta: { title: 'offerPartners.listTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['offer_partners_view'] },
        component: () => import('@/pages/offer-partners'),
    },
    {
        path: '/offer-partners/create',
        name: 'PageOfferPartnersCreate',
        meta: { title: 'offerPartners.createFormTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['offer_partners_view'] },
        component: () => import('@/pages/offer-partners/create'),
    },
    {
        path: '/offer-partners/:id/edit',
        name: 'PageOfferPartnersEdit',
        meta: { title: 'offerPartners.editFormTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['offer_partners_view'] },
        component: () => import('@/pages/offer-partners/id/edit'),
    },
]
